import * as React from 'react'
import { cn } from '@/lib/utils'
import {
  Breadcrumb,
  type BreadcrumbItem,
} from '@/design-system/molecules/Breadcrumb'

export interface PageHeaderProps extends Omit<
  React.HTMLAttributes<HTMLElement>,
  'title'
> {
  title: React.ReactNode
  description?: React.ReactNode
  breadcrumbs?: BreadcrumbItem[]
  actions?: React.ReactNode
  eyebrow?: React.ReactNode
}

export const PageHeader = React.forwardRef<HTMLElement, PageHeaderProps>(
  (
    { className, title, description, breadcrumbs, actions, eyebrow, ...rest },
    ref
  ) => (
    <header
      ref={ref}
      className={cn(
        'flex flex-col gap-3 border-b border-gray-200 pb-4 dark:border-gray-700',
        className
      )}
      {...rest}
    >
      {breadcrumbs && breadcrumbs.length > 0 && (
        <Breadcrumb items={breadcrumbs} />
      )}
      <div className="flex flex-col items-start justify-between gap-3 sm:flex-row sm:items-center">
        <div className="min-w-0 flex-1">
          {eyebrow && (
            <p className="text-xs font-semibold uppercase tracking-wide text-primary-600 dark:text-primary-400">
              {eyebrow}
            </p>
          )}
          <h1 className="truncate text-2xl font-bold leading-tight text-gray-900 dark:text-white">
            {title}
          </h1>
          {description && (
            <p className="mt-1 text-sm text-gray-500 dark:text-gray-400">
              {description}
            </p>
          )}
        </div>
        {actions && (
          <div className="flex shrink-0 items-center gap-2">{actions}</div>
        )}
      </div>
    </header>
  )
)

PageHeader.displayName = 'PageHeader'
